import React from 'react';
import {
	Navigate,
	RouterProvider,
	createBrowserRouter,
	redirect,
} from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import MainLayout from './layout/MainLayout';

import ForgotPassword from './components/auth/ResetPassword/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword/ResetPassword';
import SuccessPage from './components/auth/Success';
import ResendVerification from './components/auth/Verify/ResendVerification';
import Verify from './components/auth/Verify/Verify';
import VerifySent from './components/auth/Verify/VerifySent';
import Dashboard from './components/Dashboard';

import AddKeywords from './components/Admin/AddKeywords';
import BlogPosts from './components/Admin/BlogPosts';
import CustomerList from './components/Admin/CustomerList';
import Images from './components/Admin/Images';
import Logs from './components/Admin/Logs';
import Messages from './components/Admin/Messages';
import UserList from './components/Admin/UserList';
import ArchivePage from './components/Blog/ArchivePage';
import BlogList from './components/Blog/BlogList';
import BlogPost from './components/Blog/BlogPost';
import PrivacyPolicy from './components/Legal/PrivacyPolicy';
import Terms from './components/Legal/Terms';
import AdminLayout from './layout/AdminLayout';
import Auth, { ACCESS_TOKEN_KEY } from './utils/auth';

import MessageCard from './components/Admin/MessageCard';
import AuthForm from './components/auth/AuthForm';
import SecondaryLayout from './layout/SecondaryLayout';
import ServicesPage from './pages/ServicesPage';
import About from './components/Main/About';
import TestimonialForm from './components/Admin/AddReview';

// Component to handle protected routes
const ProtectedRoute = ({ admin = false }) => {
	console.log('protected route');
	const checkAuth = async () => {
		const token = localStorage.getItem(ACCESS_TOKEN_KEY);
		if (token) {
			const { user } = await Auth.getUser(token);

			if (user) {
				if (admin && !user.isAdmin) return redirect('/');
				if (admin && user.isAdmin) return true;
				if (!user.isVerified) return redirect('/verify');
			}
			return true; // allow through access
		}
		return false;
	};

	const isAuth = checkAuth();
	// Redirect to SignIn if no token is found
	if (!isAuth) {
		return (
			<Navigate
				to='/login'
				replace
			/>
		);
	}

	// Render children if token is found
	return <MainLayout />;
};

export const routes = [
	{
		path: '/',
		element: <MainLayout />,
		children: [
			{ path: '', element: <LandingPage /> },
			{ path: 'login', element: <AuthForm login={true} /> },
			{ path: 'signup', element: <AuthForm login={false} /> },
			{ path: 'verify', element: <Verify /> },
			{ path: 'resend-verification', element: <ResendVerification /> },
			{ path: 'forgot-password', element: <ForgotPassword /> },
			{ path: 'forgot-password/success', element: <SuccessPage /> },
			{ path: 'verify/sent', element: <VerifySent /> },
			{ path: 'reset-pw/*', element: <ResetPassword /> },

			{ path: 'blog', element: <BlogList /> },
			{ path: 'about', element: <About /> },
			{ path: 'blog/:id', element: <BlogPost /> },
			{ path: 'blog/archive', element: <ArchivePage /> },
			{
				path: '',
				element: <SecondaryLayout />,
				children: [
					{ path: 'terms', element: <Terms /> },
					{ path: 'privacy', element: <PrivacyPolicy /> },
				],
			},
			{ path: 'services', element: <ServicesPage /> },
		],
	},
	{
		path: '/',
		element: <ProtectedRoute />,
		loader: async () => {
			const isLoggedIn = Auth.isLoggedIn();
			if (isLoggedIn) {
				return null; // allow through access
			}
			return redirect('/login');
		},
		children: [{ path: 'dashboard', element: <Dashboard /> }],
	},

	{
		path: '/admin',
		element: <AdminLayout />,
		loader: async () => {
			const token = sessionStorage.getItem(ACCESS_TOKEN_KEY);
			if (token) {
				const { user } = await Auth.getUser(token);
				if (user) console.log('user', user);
				if (!user) return redirect('/login');
				if (user && !user.isAdmin) return redirect('/');
				else if (user && user.isAdmin) return null; // allow through access
			}
			return redirect('/login');
		},
		children: [
			{ index: true, path: '', element: <Dashboard /> },
			{ path: 'customers', element: <CustomerList /> },
			{
				path: 'messages',
				element: <SecondaryLayout />,
				children: [
					{ path: '', element: <Messages /> },
					{
						path: ':id',
						element: <MessageCard />,
					},
				],
			},
			{ path: 'users', element: <UserList /> },
			{ path: 'blog', element: <BlogPosts /> },
			{ path: 'images', element: <Images /> },
			{ path: 'keywords', element: <AddKeywords /> },
			{ path: 'testimonials', element: <TestimonialForm /> },
		],
	},

	{ '*': { element: <h1>Not Found</h1> } },
];
export default function Router() {
	const router = createBrowserRouter([...routes]);
	return <RouterProvider router={router} />;
}
